import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import User from 'components/User'
import UserContainer from 'components/ControlledUser'
import KanBoIcon from 'components/KanBoIcon'
import classes from './ActivityUser.module.scss'

export class ActivityUser extends React.Component {
  static propTypes = {
    fromUser: PropTypes.object.isRequired,
    userComponent: PropTypes.func.isRequired
  }

  static defaultProps = {
    userComponent: UserContainer
  }

  renderUserComponent = ({
    isActive,

    ...props
  }) => {
    return (
      <User
        {...props}
        isActive={isActive}
        draggable={isActive}
      />
    )
  }

  render () {
    const {
      fromUser,
      userComponent: UserComponent,
      className,

      ...props
    } = this.props

    switch (fromUser.type) {
      case 'USER':
        return (
          <UserComponent
            {...props}
            className={className}
            id={fromUser.id}
          >
            {this.renderUserComponent}
          </UserComponent>
        )
      case 'GUID':
        if (fromUser.guid === '3b072ba6-72ea-4a41-877d-99dd4341050b') {
          if (props.text) {
            return <FormattedMessage id='SERVICE_NAME_ALARM' />
          } else if (props.avatar) {
            return (
              <div
                className={`${classes.serviceAvatar}${className ? ` ${className}` : ''}`}
                style={{
                  width: props.size,
                  height: props.size,
                  fontSize: 24 * props.size / 40
                }}
              >
                <KanBoIcon name='kanbo-24-reminder' />
              </div>
            )
          }
        }

        if (fromUser.guid === '3db38bae-f102-41f6-977f-169ae7be63dc') {
          if (props.text) {
            return <FormattedMessage id='SERVICE_NAME_KANBO' />
          } else if (props.avatar) {
            return (
              <div
                className={`${classes.serviceAvatar}${className ? ` ${className}` : ''}`}
                style={{
                  width: props.size,
                  height: props.size,
                  fontSize: 24 * props.size / 40
                }}
              >
                <KanBoIcon name='kanbo-24-kanbo-sygnet' />
              </div>
            )
          }
        }

        return null
      case 'EMAIL':
      case 'SERVICE':
      default:
        return <User {...props} className={className} defaultMenu={false} menu={undefined} presence={false} id={fromUser.data} name={fromUser.data} />
    }
  }
}

export default ActivityUser
